import { merge, Observable } from "rxjs";
import { map, startWith, take } from "rxjs/operators";

// True until the first page is on screen. Ionic's router outlet reports that
// (stackDidChange) once the page has been rendered and its components are
// ready — later than "session resolved", because Ionic keeps its components
// invisible until their code has loaded. There is no timer: sign-in plus the
// first page can take over a minute on a slow connection. `abort$` (the
// router giving up) ends it instead, so an error is never hidden behind it.
export function bootScreenUntil(
  firstPage$: Observable<unknown>,
  abort$: Observable<unknown>
): Observable<boolean> {
  return merge(firstPage$, abort$).pipe(
    take(1),
    map(() => false),
    startWith(true)
  );
}
